/* Poppin' Pets — theme.js */
(function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('data-open');
      if (open) { nav.removeAttribute('data-open'); } else { nav.setAttribute('data-open', ''); }
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  // Variant selector -> price + availability (simple single-select per option)
  document.querySelectorAll('form.product__form').forEach(function (form) {
    var json = form.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('[name="id"]');
    var scope = form.closest('section') || document;
    var priceEl = scope.querySelector('[data-price]');
    var button = form.querySelector('[type="submit"]');

    function currentVariant() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function money(cents) {
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    }
    function update() {
      var v = currentVariant();
      if (!v) {
        button.disabled = true;
        button.textContent = button.dataset.unavailableText || 'Unavailable';
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      button.disabled = !v.available;
      button.textContent = v.available
        ? (button.dataset.addText || 'Add to cart')
        : (button.dataset.soldoutText || 'Sold out');
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });
})();
